import { APIHelper } from '@archistarai/auth-frontend';

export default {
  async index(pipelineId: number, stageId: number) {
    return APIHelper.ManageAPI.get(`pipeline/${pipelineId}/stage/${stageId}/sites`);
  }
};
